import { BankAccountVendorCustomerService } from "./../../../services/catalogs/BankAccountVendorCustomerService";
import React from "react";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { CreateBankAccountVendorCustomerDto } from "../../../dtos/catalogs/bankaccountvendorcustomerdetail/CreateBankAccountVendorCustomerDto";
import { IAppEntity } from "../../entities";
import { BankAccountVendorCustomerDetail } from "../../../components/Pages/Catalogs/BankAccountVendorCustomer/BankAccountVendorCustomerDetail";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupBankAccountVendorCustomer } from "../../../components/Shared/NewForms/NFLookupBankAccountVendorCustomer";
import BankAccountVendorCustomerList from "../../../components/Pages/Catalogs/BankAccountVendorCustomer/BankAccountVendorCustomerList";

export const BankAccountVendorCustomer: IAppEntity = {
  entityType: "catalog",
  title: "Bank Account Vendor Customer",
  pluralTitle: "Bank Account Vendor Customer",
  apiUrl: "BankAccountVendorCustomers",
  apiEnum: ReferenceTypes.CatalogBankAccountVendorCustomer,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(BankAccountVendorCustomerDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(BankAccountVendorCustomerList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupBankAccountVendorCustomer, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new BankAccountVendorCustomerService(this.apiUrl);
  },
  getEmptyModel(): CreateBankAccountVendorCustomerDto {
    return {
      name: "",
      bankId: "",
      accountNumber: "",
      foreignBank: true,
      closed: true,
      foreignBankName: "",
      currencyId: "",
      vendorCustomerId: "",
    };
  },
};

//
